import React, { FC } from "react";
import { Svg, G, Polygon, Path } from "react-native-svg";

const FirePiece: FC = () => {
  return (
    <>
      <Svg viewBox="0 0 1567 1547.42">
        <G scale={0.8} translate={[156.7, 140]}>
          <Polygon
            stroke="#EF0750"
            strokeWidth="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            points="
		1378.826,1031.494 783.5,0.359 188.173,1031.494 783.5,1547.062 	"
          />
          <Path
            fill="#EF0750"
            stroke="#EF0750"
            strokeWidth="20"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
		M1185.126,969.45l-6.792-66.758l-10.036-46.428l-13.307-44.551l-24.651-64.993l-29.831-64.921l-34.567-62.684l-62.803-93.147
		l-30.829-40.284l-24.844-31.163l-55.478-67.299l-44.162-52.415l-22.062-19.938l-12.795-8.245l-5.335-3.481l-8.925-6.213
		l-9.014-6.274l-9.109-6.353l-9.075-6.324l-9.083-6.322l-57.136-39.792l-16.02,83.469l-5.877,30.515l-1.538,8.025l-0.433,2.192
		l-0.125,0.649l-0.061,0.341l-3.072,21.018l2.135,21.459l3.623,13.539l5.763,15.134l14.442,43.098l5.714,36.789l-19.167-11.463
		l-14.892-9.277l-43.739-13.43l-99.034,23.99l3.392,93.01l14.098,30.884l5.534,7.797l10.053,18.002l7.335,29.381l-2.754,30.12
		l-13.496,27.209l-11.512,12.68l-17.803,16.112l-17.784,15.175l-19.979,17.922l-30.389,32.975l-25.085,37.437l-18.287,42.211
		l-10.824,55.142l2.096,57.47l17.174,63.565l27.099,52.592l23.784,34.533l23.579,30.266l51.738,63.047l40.228,48.04l14.359,16.142
		l8.683,9.336l17.906,17.27l19.963,14.83l21.693,12.177l23.069,9.29l24.072,6.287l24.67,3.144l24.872-0.023l24.67-3.195l5.725-0.471
		l13.763-1.507l16.911-3.942l21.53-9.184l75.461-43.018l61.434-39.048l32.534-23.274l32.38-25.72l49.838-48.216l37.604-52.459
		l25.514-57.008l13.564-57.869L1185.126,969.45z M1089.689,1069.091l-18.622,41.773l-28.027,39.017l-41.219,39.83l-58.728,44.208
		l-56.457,35.873l-74.136,42.235l-12.497,3.644l-17.547,1.746l11.485-27.863l44.18-50.314l54.994-64.962l21.323-32.016
		l18.903-44.804l12.488-72.244l-1.375-46.419l-10.842-46.462l-11.571-36.799l-14.726-46.842l-9.318-21.092l-13.625-26.23
		l-6.549,0.672l-5.298,12.971l-5.678,16.749l-9.429,27.009l-14,24.098l-21.589,28.261l-22.34,27.771l-4.862,4.513l-7.737,3.861
		l-1.531,0.344l-1.589,0.029l-1.551-0.3l-1.457-0.608l-1.295-0.9l-1.089-1.14l-0.827-1.348l-0.535-1.482l-1.365-6.057l-1.138-6.112
		l-0.906-6.146l-0.667-6.179l-0.438-6.197l-0.199-6.213l0.043-6.216l0.27-6.207l-0.363-20.448l-6.67-25.934l-4.313-7.298
		l-6.634-8.801l-5.625,5.743l-3.317,3.736l-2.182,4.093l-14.592,31.012l-29.694,31.818l-34.702,29.005l-43.32,37.978l-12.979,18.053
		l-8.66,25.246l-3.517,34.864l6.419,28.692l31.675,58.057l37.858,75.017l7.068,28.445l3.72,38.578l-7.724,3.1l-9.212-9.918
		l-11.456-12.837l-40.244-48.077l-50.628-61.668l-41.87-57.039l-20.501-39.703l-12.079-44.545l-1.5-39.531l7.038-35.974
		l20.296-41.259l31.775-36.967l34.79-30.44l21.716-19.662l19.306-21.507l23.418-42.495l9.77-46.266l-2.084-40.096l-11.316-39.022
		l-20.268-36.22l-3.96-8.668l-0.337-9.518l11.753-2.848l11.572,3.548l54.882,33.35l31.542,25.345l24.209,34.017l3.098,4.461
		l4.31,3.276l5.116,1.799l5.423,0.134l5.196-1.55l4.471-3.074l3.303-4.304l1.804-5.11l1.362-7.57l1.238-7.595l1.132-7.605
		l1.013-7.617l0.904-7.646l0.79-7.647l0.67-7.664l0.566-7.677l-0.134-87.953l-8.891-54.803l-18.548-53.442l-2.066-5.466
		l-1.897-7.227l-0.061-1.176l0.239-1.492l1.515-6.725l11.172,7.072l11.763,9.272L828.822,440l54.872,66.556l23.982,30.089
		l29.759,38.898l57.816,85.621l59.051,117.068l22.646,59.691l20.208,78.315l5.614,55.103l-2.821,53.801L1089.689,1069.091z"
          />
        </G>
      </Svg>
    </>
  );
};

export { FirePiece };
